<template>
  <b-modal id="modal-2">
    <!--Content-->
    <template slot="modal-header">
      <div class>
        <!--Header-->
        <div>
          <i class="fa fa-2x fa-orange fa-exclamation-triangle mb-3 slow-spin animated"></i>
        </div>
      </div>
    </template>

    <!--Body-->
    <div class="modal-body">
      <div style="float: left;">
        <p>
          Are you sure you want to delete this
          <slot name="entityType" />?
        </p>
        <span class="heading lead" style="text-align: left;">
          <slot name="header"></slot>
        </span>
        <span class="heading lead" style="text-align: left;">
          <slot name="details"></slot>
        </span>
      </div>
    </div>

    <!--Footer-->
    <template slot="modal-footer">
      <div slot class="modal-footer justify-content-center" style="border:none;">
        <b-button
          class="mr-2"
          type="submit"
          size="md"
          variant="outline-primary"
          data-dismiss="modal"
          @click="$bvModal.hide('modal-2')"
          aria-label="Close"
        >Cancel</b-button>
        <a type="button" class="btn btn-primary text-white" @click="DeleteConfirmed">
          Yes, I'm sure
          <i class="fa fa-trash ml-1 text-white"></i>
        </a>
      </div>
    </template>

    <!--/.Content-->
  </b-modal>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState(["n_user"]),
    ...mapActions("n_user", ["Delete"])
  },
  methods: {
    DeleteConfirmed() {
      //alert("here");
      //alert(this.CurrentObject.UserProfileID);
      this.$store
        .dispatch("n_user/Delete", this.CurrentObject)
        .then(response => {
          this.$bvModal.hide("modal-2");
        });
      //this.$store.dispatch("n_user/Delete", this.CurrentObject);
    }
  },
  props: {
    CurrentObject: Object
  },
  updated() {}
};
</script>
